export var renderFilterViewerEnumConditionValue = function renderFilterViewerEnumConditionValue(condition, conditionType, conditionValue) {
  var multiple = condition.multiple;

  var _conditionType$getAtt = conditionType.getAttributes(),
      options = _conditionType$getAtt.options;

  var _ref = conditionValue || {},
      value = _ref.value;

  if (value === undefined || value === null) {
    return '';
  }

  var optionIndex = {};

  if (options) {
    options.forEach(function (_ref2) {
      var label = _ref2.label,
          optionValue = _ref2.value;
      optionIndex[optionValue] = label;
    });
  }

  var result = [];

  if (multiple) {
    if (Array.isArray(value)) {
      value.forEach(function (valueItem) {
        result.push(optionIndex[valueItem] || valueItem);
      });
    }
  } else {
    result.push(optionIndex[value] || value);
  }

  return result;
};